var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
export const PrimaryGrid = (_a) => {
    var _b;
    var { title, paginationModel, isFullPage, autoHeight = false, onPaginationModelChange, heightVariant, gridHeight } = _a, dataGridProps = __rest(_a, ["title", "paginationModel", "isFullPage", "autoHeight", "onPaginationModelChange", "heightVariant", "gridHeight"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation();
    // Height precedence: explicit sx > heightVariant > props > fallback
    const effectiveHeight = gridHeight !== null && gridHeight !== void 0 ? gridHeight : (heightVariant === "auto"
        ? "auto"
        : heightVariant === "mobile"
            ? 330
            : heightVariant === "full" || isFullPage
                ? isMobile
                    ? "400px"
                    : "calc(100dvh - 358px)"
                : heightVariant === "half"
                    ? "calc(52dvh - 16px)"
                    : autoHeight
                        ? "auto"
                        : isMobile
                            ? 330
                            : "calc(52dvh - 16px)");
    return (React.createElement(Box, { sx: {
            height: effectiveHeight,
            backgroundColor: "transparent",
            width: "100%",
        } },
        React.createElement(DataGrid, Object.assign({}, dataGridProps, { sx: Object.assign(Object.assign(Object.assign(Object.assign({}, dataGridProps.sx), { "& .MuiDataGrid-virtualScroller": Object.assign({}, (((_b = dataGridProps.rows) === null || _b === void 0 ? void 0 : _b.length) === 0 && {
                    overflow: "hidden !important",
                    minHeight: "auto !important",
                    height: "auto !important",
                })) }), (dataGridProps.onRowClick && {
                "& .MuiDataGrid-row": {
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "action.hover",
                    },
                },
            })), { 
                // Prevent loading overlays from blocking interactions
                "& .MuiDataGrid-overlayWrapper": {
                    pointerEvents: "none !important",
                    "& *": {
                        pointerEvents: "none !important",
                    },
                }, "& .MuiDataGrid-overlay": {
                    pointerEvents: "none !important",
                }, "& .MuiDataGrid-loadingOverlay": {
                    pointerEvents: "none !important",
                } }), slotProps: {
                loadingOverlay: {
                    variant: "skeleton",
                    noRowsVariant: "skeleton",
                },
                pagination: {
                    labelRowsPerPage: "Rijen per pagina:",
                    labelDisplayedRows: ({ from, to, count }) => `${from}-${to} van ${count !== -1 ? count : `meer dan ${to}`}`,
                },
            }, slots: { noRowsOverlay: CustomNoRowsOverlay, }, disableColumnFilter: dataGridProps.disableColumnFilter !== undefined ? dataGridProps.disableColumnFilter : true, disableColumnResize: true, columnHeaderHeight: 56, pageSizeOptions: [10, 20, 30, 50, 100], disableColumnMenu: dataGridProps.disableColumnMenu !== undefined ? dataGridProps.disableColumnMenu : true, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange }))));
};
const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .no-rows-primary": Object.assign({ fill: "#3D4751" }, theme.applyStyles("light", {
        fill: "#AEB8C2",
    })),
    "& .no-rows-secondary": Object.assign({ fill: "#1D2126" }, theme.applyStyles("light", {
        fill: "#E8EAED",
    })),
}));
function CustomNoRowsOverlay() {
    return (React.createElement(StyledGridOverlay, null,
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", width: 96, viewBox: "0 0 452 257", "aria-hidden": true, focusable: "false" },
            React.createElement("path", { className: "no-rows-primary", d: "M348 69c-46.392 0-84 37.608-84 84s37.608 84 84 84 84-37.608 84-84-37.608-84-84-84Zm-104 84c0-57.438 46.562-104 104-104s104 46.562 104 104-46.562 104-104 104-104-46.562-104-104Z" }),
            React.createElement("path", { className: "no-rows-primary", d: "M308.929 113.929c3.905-3.905 10.237-3.905 14.142 0l63.64 63.64c3.905 3.905 3.905 10.236 0 14.142-3.906 3.905-10.237 3.905-14.142 0l-63.64-63.64c-3.905-3.905-3.905-10.237 0-14.142Z" }),
            React.createElement("path", { className: "no-rows-primary", d: "M308.929 191.711c-3.905-3.906-3.905-10.237 0-14.142l63.64-63.64c3.905-3.905 10.236-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142l-63.64 63.64c-3.905 3.905-10.237 3.905-14.142 0Z" }),
            React.createElement("path", { className: "no-rows-secondary", d: "M0 10C0 4.477 4.477 0 10 0h380c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 20 0 15.523 0 10ZM0 59c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 69 0 64.523 0 59ZM0 106c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 153c0-5.523 4.477-10 10-10h195.5c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 200c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 247c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10Z" })),
        React.createElement(Box, { sx: { mt: 2 } }, "Geen gegevens")));
}
